<template>
  <div>
    <div class="row">
      <div class="col-lg-4 col-md-4">
        <user-card v-if="initialized" :auth-details="authDetails"></user-card>
      </div>
      <div class="col-lg-8 col-md-8">
        <edit-company-form v-if="initialized" :auth-details="authDetails"></edit-company-form>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-7">
        <plan-details :auth-details="authDetails"></plan-details>
      </div>
      <div class="col-lg-5">
        <payment-method></payment-method>
        <edit-mws-form v-if="initialized" :auth-details="authDetails"></edit-mws-form>
        <members-card v-if="false"></members-card>
      </div>
    </div>
  </div>
</template>
<script>
  import db from '@/components/firebase/init'
  import firebase from 'firebase'
  import EditCompanyForm from './partials/EditCompanyForm.vue'
  import EditProfileForm from './partials/EditProfileForm.vue'
  import EditMwsForm from './partials/EditMwsForm.vue'
  import PlanDetails from './partials/PlanDetails.vue'
  import UserCard from './partials/UserCard.vue'
  import MembersCard from './partials/MembersCard.vue'
  import PaymentMethod from './partials/PaymentMethod'
  import { toolboxMixin } from '@/components/mixins/toolboxMixin'
  import { EventBus } from '@/eventBus'

  export default {
    components: {
      EditCompanyForm,
      EditProfileForm,
      EditMwsForm,
      PlanDetails,
      UserCard,
      MembersCard,
      PaymentMethod
    },
    mixins: [toolboxMixin],
    data () {
      return {
        authDetails: {},
        initialized: false
      }
    },
    methods: {
      async init () {
        this.authDetails = await this.getAuthDetails()
        this.initialized = true
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        this.init()
        EventBus.$on('auth-refreshed', () => {
          this.init()
        })
      })
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Account/Account.vue